import { useMutation } from "@tanstack/react-query";
import { getReturnWidgetBaseUrl } from "./return-widget-client";

export type CreateGiftReturnPayload = {
  token?: string;
  giftCode?: string;
  email: string;
  phone: string;
  address: {
    first_name?: string;
    last_name?: string;
    address1: string;
    address2?: string;
    city: string;
    zip: string;
    country_code?: string;
    country?: string;
  };
};

export async function publicCreateGiftReturn(
  payload: CreateGiftReturnPayload,
): Promise<void> {
  const base = getReturnWidgetBaseUrl().replace(/\/$/, "");
  const response = await fetch(`${base}/public/gift-codes/create-return`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    // /public/ : auth par le corps (token/giftCode), pas de cookie (BAB-3040).
    credentials: "omit",
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw Object.assign(new Error("Failed to create gift return"), {
      code: body?.code,
      status: response.status,
    });
  }
}

export function usePublicCreateGiftReturn() {
  return useMutation({ mutationFn: publicCreateGiftReturn });
}
